import { useEffect, useState } from "react";
import { CloseCircleIcon } from "../../../../assets/icons";
import Avatar from "../../../../common/components/avatar/avatar";
import CommonSideDialog from "../../../../common/components/side-dialog/CommonSideDialog";
import TabSelector from "../../../../common/components/tab-selector/TabSelector";
import { useLazyGetOrderDetailsQuery, useLazyGetOrderRepaymentDetailsQuery } from "../../../../service/order-service";
import styles from "./OrderDetailsSideDailog.module.scss";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../../../../stores/slices/loader-slice";
import CommonPagination from "../../../../common/components/pagination/CommonPagination";
import { formatDate } from "../../../../utils";

interface OrderDetailSideDialogProps {
	orderId: string;
	handleCloseDialog: () => void;
}

const OrderDetailSideDialog: React.FC<OrderDetailSideDialogProps> = ({ orderId, handleCloseDialog }) => {
	const dispatch = useDispatch();
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(0);
	const [getCustomerOrderDetails, { data }] = useLazyGetOrderDetailsQuery();
	const [getRepaymentList, { data: repaymentList, isLoading }] = useLazyGetOrderRepaymentDetailsQuery();

	useEffect(() => {
		dispatch(showLoader());
		getCustomerOrderDetails(orderId)
			.unwrap()
			.then()
			.catch(err => toast.error(err?.data?.title as string))
			.finally(() => dispatch(hideLoader()));
		handleRepaymentList();
	}, []);

	useEffect(() => {
		handleRepaymentList();
	}, [currentPage]);

	const handleRepaymentList = () => {
		getRepaymentList({ orderId, Page: currentPage, PageSize: 5 })
			.unwrap()
			.then(res => setTotalPages(res?.totalPages))
			.catch(err => toast.error(err?.data?.title as string));
	};

	const tabs = [{ id: 1, title: "Repayment Details", onClick: () => {} }];
	return (
		<CommonSideDialog onCloseDialog={handleCloseDialog}>
			<div className={styles.contentWrapper}>
				<div className={styles.header}>
					<div className={styles.businessNameSection}>
						{/* <Avatar className={styles.avatar} placeholder="GN" />
						<span className={styles.businessName}>Business Name</span>
						<span className={styles.breaker}></span> */}
						<span className={styles.businessLabel}>{data?.customerName}</span>
					</div>
					<div className={styles.closeButton} onClick={handleCloseDialog}>
						<CloseCircleIcon />
					</div>
				</div>
				<div className={styles.borderContainer}>
					<div className={styles.businessInfoSection}>
						<div className={styles.innerSection}>
							<div className={styles.row}>
								<div className={styles.label}>Initial Deposit</div>
								<div className={`${styles.labelValue}`}>₦ {data?.initialDeposit?.toLocaleString()}</div>
							</div>
							<div className={styles.row}>
								<div className={styles.label}>Loan (Principal)</div>
								<div className={styles.labelValue}>₦ {data?.loanPrincipal?.toLocaleString()}</div>
							</div>
							<div className={styles.row}>
								<div className={styles.label}>Loan interest</div>
								<div className={styles.labelValue}>₦ {data?.loanInterest?.toLocaleString()}</div>
							</div>
							<div className={styles.row}>
								<div className={styles.label}>Amount Paid Back</div>
								<div className={`${styles.labelValue} ${styles.comboLabel}`}>
									₦ {data?.amountPaidBack?.toLocaleString()}
									{/* <CopyIcon height={16} onClick={() => handleCopy("text")} /> */}
								</div>
							</div>
							<div className={styles.row}>
								<div className={styles.label}>Amount Outstanding</div>
								<div className={styles.labelValue}>₦ {data?.outstandingAmount?.toLocaleString()}</div>
							</div>
							<div className={styles.row}>
								<div className={styles.label}>Duration</div>
								<div className={`${styles.labelValue} ${styles.comboLabel}`}>{data?.durationInMonths} Months</div>
							</div>
						</div>
					</div>
				</div>
				<div className={styles.tabContainer}>
					<TabSelector tabs={tabs} selectedTab={1} />
				</div>
				<div className={styles.tableContainer}>
					<table className="standardTable">
						<thead>
							<tr>
								<th>AMOUNT PAID BACK</th>
								<th>DATE OF REPAYMENT</th>
								<th>PAYMENT METHOD</th>
								<th>PAYMENT REFERENCE</th>
								<th>STATUS</th>
								{/* <th>VIEW DETAILS</th> */}
							</tr>
						</thead>
						<tbody>
							{repaymentList?.items?.map((order, index) => (
								<tr key={index}>
									<td>₦ {order?.amount?.toLocaleString()}</td>
									<td>{formatDate(order?.dateOfPayment)}</td>
									<td>{order?.type}</td>
									<td>{order?.reference}</td>
									<td>{order?.status}</td>
									{/* <td>Aug 4, 2024</td> */}
								</tr>
							))}
						</tbody>
					</table>
				</div>
				<div style={{ marginLeft: 20}}>
				<CommonPagination
					currentPage={currentPage}
					isLoading={isLoading}
					numberOfPages={totalPages}
					onPageChange={(page: number) => {
						setCurrentPage(page);
					}}
				/>
				</div>
			</div>
		</CommonSideDialog>
	);
};

export default OrderDetailSideDialog;
